import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/l/approve')({
  validateSearch: (raw: Record<string, unknown>): { id?: string; token?: string } => ({
    id: typeof raw.id === 'string' ? raw.id : undefined,
    token: typeof raw.token === 'string' ? raw.token : undefined,
  }),
})
